/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Grower_Report_Col_MaterialInputs */

const vi_my_grower_report_col_material = /** @type {(inputs: My_Grower_Report_Col_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vật tư`)
};

/**

* @param {My_Grower_Report_Col_MaterialInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const my_grower_report_col_material = /** @type {((inputs?: My_Grower_Report_Col_MaterialInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Grower_Report_Col_MaterialInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_my_grower_report_col_material(inputs)
});